import styled from 'styled-components'

const Wrapper = styled.div`
  background-color: var(--Grey300);
  ${({ isHome }) => isHome ? `
    // max-width: 52rem;
    margin: 0rem;
    height: calc(100% - 56px);
    display: flex;
    // align-items: center;
    margin:8px 0 0 0;
    `: `
    padding: 24px;
    min-height: 100vh; 
  `}

  @media (max-width: 600px) {
    padding: 0;
    min-height: unset;  
    margin:4px 0 0 0;
  }
`

const ErrorMessage = styled.div`
  font-size:12px;
  color: rgb(221, 54, 35);
  margin-top: 0.5rem;
`

const Container = styled.div`
  display: flex;
  // align-items: center;
  justify-content: center;
  background-size: cover;
  width:100%;
`
const MainDiv = styled.div`
  display: flex;
  margin: ${({ isHome }) => isHome ? 'unset' : 'auto'};
  width: ${({ isHome }) => '900px'};
  min-height: ${({ isHome }) => isHome ? '150px' : '512px'};
  ${({isHome, isMobile}) => isHome && !isMobile ? "height: 450px" : ""};
  @media (max-width: 600px) {
    display:  ${({ referrer }) => referrer === "reader_screen" ? "block" : "flex"};
    width: 100%;
    height: ${({ referrer }) => referrer === "reader_screen" ? "100%" : "unset"};
    min-height: unset;
  }
`
const LeftDiv = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background:${props=> props.userLanguages === "hindi" || props?.isUgcUser ? "#000" : "linear-gradient(to bottom,#335973,#044673)"};
  @media (max-width: 600px) {
    width: 100%;
    display:  ${({ referrer }) => referrer === "reader_screen" ? "block" : "none"};
  }
`
const RightDiv = styled.div`
  width: 50%;
  padding:${({ isHome }) => isHome ? "1rem 1.5rem" : "64px 48px"};
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  ${({isHome}) => isHome ? "justify-content:center" : ""};
  ${({isHome}) => isHome ? "height: 100%" : ""};

  @media (max-width: 600px) {
    width: 100%;
    padding: 24px 16px;
  }
`

export {
    Wrapper,
    ErrorMessage,
    Container,
    LeftDiv,
    MainDiv,
    RightDiv
}